import { InventoryTypeField } from "../responses/inventory_type/InventoryTypeField"
import { InventoryTypeFieldValueDetails } from "../responses/inventory_type/InventoryTypeFieldValueDetails"

export class InventoryTypeFieldAndValueModel {
  field: InventoryTypeField
  value: InventoryTypeFieldValueDetails

  constructor(field: InventoryTypeField, value: InventoryTypeFieldValueDetails) {
    this.field = field
    this.value = value
  }
}
  